import React from 'react'
import { Heading } from 'base-ui'
import Highlighter from './Highlight'
import { Heading as HeadingExample } from '../examples/Heading'
import { PageWrapper } from './PageWrapper'

const Headings = () => {
  return (
    <PageWrapper title="Headings">
        <Heading size="h1">Heading 1</Heading>
        <Heading size="h2">Heading 2</Heading>
        <Heading size="h3">Heading 3</Heading>
        <Heading size="h4">Heading 4</Heading>
        <Heading size="h5">Heading 5</Heading>
        <Heading size="h6">Heading 6</Heading>
        <div className="py-4">
          <Highlighter code={HeadingExample} language='jsx' />
        </div>
      
    </PageWrapper>
  )
}

export default Headings
